export const cityCoords = {
  vilnius: {
    latitude: 54.687157,
    longitude: 25.279652,
    zoom: 15,
    altitude: 2300,
    radius: 30,
  },
};
